import { Button as ButtonPrimitive } from "@base-ui/react/button"
import type * as React from "react"

import { cn } from "../../lib/utils"
import { buttonVariants, type ButtonVariantProps } from "./button-variants"
import { Spinner } from "./spinner"

function Button({
  className,
  variant = "default",
  size = "default",
  radius = "default",
  layout = "default",
  children,
  disabled,
  loading = false,
  type,
  ...props
}: ButtonPrimitive.Props &
  ButtonVariantProps & {
    loading?: boolean
  }) {
  const resolvedSize = variant === "inline" && size === "default" ? "inline" : size
  const isDisabled = Boolean(disabled || loading)

  return (
    <ButtonPrimitive
      data-slot="button"
      data-loading={loading ? "" : undefined}
      aria-disabled={loading || undefined}
      disabled={isDisabled}
      type={type ?? ("button" as React.ButtonHTMLAttributes<HTMLButtonElement>["type"])}
      className={cn(buttonVariants({ variant, size: resolvedSize, radius, layout }), className)}
      {...props}
    >
      <span className={cn("inline-flex items-center", loading && "invisible")}>
        {children}
      </span>
      {loading ? <Spinner className="pointer-events-none absolute" data-slot="button-loading-indicator" /> : null}
    </ButtonPrimitive>
  )
}

export { Button, buttonVariants }
